// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"Vr-z","badgeLink":"Wr-z","category":"Xr-z"};